var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboardAlertsicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2584 4.87502L11.3083 2.01669C10.5 1.55002 9.50002 1.55002 8.68335 2.01669L3.74168 4.87502C2.93335 5.34169 2.43335 6.20835 2.43335 7.15002V12.85C2.43335 13.7834 2.93335 14.65 3.74168 15.125L8.69168 17.9834C9.50002 18.45 10.5 18.45 11.3167 17.9834L16.2667 15.125C17.075 14.6584 17.575 13.7917 17.575 12.85V7.15002C17.5667 6.20835 17.0667 5.35002 16.2584 4.87502ZM9.37502 6.45835C9.37502 6.11669 9.65835 5.83335 10 5.83335C10.3417 5.83335 10.625 6.11669 10.625 6.45835V10.8334C10.625 11.175 10.3417 11.4584 10 11.4584C9.65835 11.4584 9.37502 11.175 9.37502 10.8334V6.45835ZM10.7667 13.8584C10.725 13.9584 10.6667 14.05 10.5917 14.1334C10.4333 14.2917 10.225 14.375 10 14.375C9.89168 14.375 9.78335 14.35 9.68335 14.3084C9.57502 14.2667 9.49168 14.2084 9.40835 14.1334C9.33335 14.05 9.27502 13.9584 9.22502 13.8584C9.18335 13.7584 9.16668 13.65 9.16668 13.5417C9.16668 13.325 9.25002 13.1084 9.40835 12.95C9.49168 12.875 9.57502 12.8167 9.68335 12.775C9.99168 12.6417 10.3583 12.7167 10.5917 12.95C10.6667 13.0334 10.725 13.1167 10.7667 13.225C10.8083 13.325 10.8334 13.4334 10.8334 13.5417C10.8334 13.65 10.8083 13.7584 10.7667 13.8584Z",
    fill: "#EB5757"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardAlertsicon);
export default __webpack_public_path__ + "static/media/Dashboard - alerts icon.cc408406fdb190e0e27c02edacf8d25a.svg";
export { ForwardRef as ReactComponent };